<ng-container *ngFor="let x of cash">
    <a type="button" [class.disabled]="!isEnabled" class="btn btn-default" (click)="onCashClick(x)">{{x.toStringCurrencySign()}}</a>
</ng-container>
